export const referalFilterArray=[
            {
                'id' : 1, 
                'name' : 'Pending for Assignment'
            }, 
            {
                'id' : 2, 
                'name' : 'Referral Assigned'
            }, 
            {
                'id' : 3, 
                'name' : 'Referral Rejected'
            },
            {
                'id' : 4, 
                'name' : 'Referral Closed'
            },
            {
                'id' : 5, 
                'name' : 'Referral On Hold'
            },
            {
                'id' : 6, 
                'name' : 'Order Won'
            },
            {
                'id' : 7, 
                'name' : 'Order Lost'
            }
        ];

export const rejectionReason = {
    1: "Not Picked",
    2: "Wrong Number",
    3: "Not Interested",
    4: "Existing client of Park+",
    5: "Loss to competitor",
    6: "Others",
};

export const STATUS_PENDING = '1';
export const STATUS_ASSIGNED = '2';
export const STATUS_REJECTED = '3';
export const STATUS_CLOSED = '4';
export const STATUS_ON_HOLD = '5';
export const STATUS_ORDER_WON = '6';
export const STATUS_ORDER_LOST = '7';

export const REJECTION_REASON_NOT_PICKED = '1';
export const REJECTION_REASON_WRONG_NUMBER = '2';
export const REJECTION_REASON_NOT_INTERESTED = '3';
export const REJECTION_REASON_EXISTING_CLIENT = '4';
export const REJECTION_REASON_LOSS_TO_COMP = '5';
export const REJECTION_REASON_OTHERS = '6';
